// extracted by mini-css-extract-plugin
module.exports = {"errorWrap":"Error_errorWrap__xGcof","err":"Error_err__3-YyY"};